/** The glyphs the rows draw and nothing else does (moved from `quote/quote-rows.tsx` at step 8). */
import { IconGrip, IconPlus } from '../../frame/icons.js'

// ---------------------------------------------------------------------------
// The glyphs this file needs and nothing else does
// ---------------------------------------------------------------------------

const stroke = {
  fill: 'none',
  stroke: 'currentColor',
  strokeWidth: 1.7,
  strokeLinecap: 'round' as const,
  strokeLinejoin: 'round' as const,
}

/** A calendar with a tick: a trip to the property that is planned. */
function IconVisit({ size = 18 }: { size?: number }) {
  return (
    <svg viewBox="0 0 24 24" width={size} height={size} {...stroke} aria-hidden>
      <rect x="3" y="5" width="18" height="16" rx="2" />
      <path d="M3 10h18M8 3v4M16 3v4M9 15l2 2 4-4" />
    </svg>
  )
}

/**
 * Layers: one thing done on a visit, made of the lines beneath it.
 *
 * It was a wireframe cube, and at 15px the cube's three inner edges met in
 * the middle and filled it in — a dark lozenge rather than a box.
 */
function IconService({ size = 15 }: { size?: number }) {
  return (
    <svg viewBox="0 0 24 24" width={size} height={size} {...stroke} aria-hidden>
      <path d="M12 3l9 5-9 5-9-5 9-5z" />
      <path d="M3 16l9 5 9-5" />
    </svg>
  )
}

/** A table: a recipe with rows — the badge on a service built from a package. */
function IconRecipe({ size = 13 }: { size?: number }) {
  return (
    <svg viewBox="0 0 24 24" width={size} height={size} {...stroke} aria-hidden>
      <rect x="3" y="4" width="18" height="16" rx="2" />
      <path d="M3 10h18M9 4v16M15 10v10" />
    </svg>
  )
}

function IconRepeat({ size = 13 }: { size?: number }) {
  return (
    <svg viewBox="0 0 24 24" width={size} height={size} {...stroke} aria-hidden>
      <path d="M17 2l4 4-4 4M3 11V9a4 4 0 0 1 4-4h14M7 22l-4-4 4-4M21 13v2a4 4 0 0 1-4 4H3" />
    </svg>
  )
}

function IconMoney({ size = 13 }: { size?: number }) {
  return (
    <svg viewBox="0 0 24 24" width={size} height={size} {...stroke} aria-hidden>
      <path d="M12 3v18M16 7H10a2.5 2.5 0 0 0 0 5h4a2.5 2.5 0 0 1 0 5H8" />
    </svg>
  )
}

export function IconNoteLines({ size = 13 }: { size?: number }) {
  return (
    <svg viewBox="0 0 24 24" width={size} height={size} {...stroke} aria-hidden>
      <path d="M5 4h14v12l-4 4H5z" />
      <path d="M15 16v4M8 9h8M8 13h5" />
    </svg>
  )
}

/** The five line kinds, each recognisable at 14px. */
export { IconVisit, IconService, IconRecipe, IconRepeat, IconMoney }
export { IconPlus, IconGrip }
